import React, { useState } from "react";

import { Layout, MetaTag } from "src/components";
import BookForm from "../../../components/BookForm";
import { Card, Col, Row, Spin } from "antd";

const CreateView = (props: any) => {
    const { onFinish, onFinishFailed } = props;

    return (
        <Layout
            titles={[
                { name: "Books", link: "/book" },
                { name: "New", link: "" },
            ]}
        >
            <MetaTag title="Add Book" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"Book Create"}
                        bordered={true}
                    >
                        <BookForm
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                        />
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default CreateView;
